import { Skeleton } from './Skeleton';
import styles from './SkeletonCard.module.scss';

export interface SkeletonCardProps {
  /** Additional CSS class */
  className?: string;
}

/**
 * Skeleton placeholder that matches the exact size and shape of a real Post card.
 * Contains only a centered avatar circle — the card itself occupies the same
 * dimensions as a loaded post so there's no layout shift on load.
 */
export function SkeletonCard({ className }: SkeletonCardProps) {
  const classes = [styles.skeletonCard, className].filter(Boolean).join(' ');

  return (
    <div className={classes} aria-hidden="true">
      <Skeleton width="40px" height="40px" borderRadius="50%" />
    </div>
  );
}

export default SkeletonCard;
